import React from 'react';
import Navbar from '../components/profile-components/Navbar';
import Topbar from '../components/profile-components/Topbar';
import './Tasks.css';

function Tasks() {
  return (
    <>
      <Navbar />
      <Topbar />
      <div className="main-content">
        <h1>Tasks Page</h1>
        <p>Welcome to the Tasks page! This is a simple test page to verify routing and layout.</p>
      </div>
    </>
  );
}

export default Tasks;
